import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { useWindowSize } from 'src/modules/store/windowSizeStore';
import { PwaPopup } from './components/PwaPopup';
import './styles.css';

interface HeaderProps {
  children: ReactNode;
  accountHeader?: boolean;
  hideHeaderInDesctopView?: boolean;
  hideHeaderInAccountDesctopView?: boolean;
  additionalClassName?: string;
  accountHeaderChildren?: ReactNode;
}

export const Header: FC<HeaderProps> = ({
  children,
  accountHeader = false,
  additionalClassName,
  accountHeaderChildren
}) => {
  const { is640 } = useWindowSize('is640');

  return (
    <div className={classNames('w-full sticky top-0 left-0 right-0 bg-h_bg', additionalClassName)}>
      <div className="shadow-xl">
        {!is640 && <PwaPopup />}
        <header
          className={classNames(
            'flex justify-center items-center',
            accountHeader && 'flex-col 1024:flex-row 1024:h-[unset]'
          )}>
          <div
            className={classNames(
              'w-full flex justify-center items-center',
              accountHeader && 'h-full 1024:pt-0'
            )}>
            {children}
          </div>
        </header>
      </div>
      {accountHeader ? (
        <div className="flex 1024:hidden justify-center items-center bg-h_bg mt-2">
          {accountHeaderChildren}
        </div>
      ) : null}
    </div>
  );
};
